module.exports = __webpack_public_path__ + "img/zip.8cf194ba.svg";